var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLinkWhite = function SvgExternalLinkWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m23.325 0-7.65.008A.675.675 0 0 0 15 .683v1.561a.675.675 0 0 0 .689.675l3.451-.127.097.096L6.165 15.961a.56.56 0 0 0 0 .796l1.078 1.078a.563.563 0 0 0 .797 0L21.112 4.764l.096.097-.127 3.451a.674.674 0 0 0 .675.689h1.561a.675.675 0 0 0 .675-.675L24 .675A.675.675 0 0 0 23.325 0M20.25 13.5h-.75a.75.75 0 0 0-.75.75v7.219a.28.28 0 0 1-.281.281H2.53a.28.28 0 0 1-.281-.281V5.53a.28.28 0 0 1 .281-.281H9.75a.75.75 0 0 0 .75-.75v-.75A.75.75 0 0 0 9.75 3h-7.5A2.25 2.25 0 0 0 0 5.25v16.5A2.25 2.25 0 0 0 2.25 24h16.5A2.25 2.25 0 0 0 21 21.75v-7.5a.75.75 0 0 0-.75-.75"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgExternalLinkWhite;